// impactData.ts
import { ShieldCheck, Sun, TrendingUp } from "lucide-react";

export const impactData = {
  title: {
    mainTitle: "WHY CHOOSE US?",
    heading: "A Positive Impact for Your Home and the Planet",
  },
  cards: [
    {
      icon: <ShieldCheck className="text-white w-6 h-6" />,
      title: "Trusted Rooftop Solar Company",
      description:
        "Proven expertise in delivering reliable solar solutions with high efficiency and durability.",
    },
    {
      icon: <Sun className="text-white w-6 h-6" />,
      title: "Optimized Energy Efficiency",
      description:
        "Reduce electricity bills and dependence on grid power with our cutting-edge solar technology.",
    },
    {
      icon: <TrendingUp className="text-white w-6 h-6" />,
      title: "End-to-End Project Execution",
      description:
        "From design to installation and maintenance, we provide a seamless solar energy experience.",
    },
  ],
};
